import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import {MatBadgeModule} from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterLink } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AppTitleService } from '../../services/app-title.service';
import { AuthService } from '../../services/auth.service';
import { AgCharts, AgChartsModule } from 'ag-charts-angular';
import { AgChartOptions } from 'ag-charts-community'
import { ChartsService } from '../../shared/charts.service';
import { global } from '../../shared/global';
import { interval } from 'rxjs';
import { TreeAutocompleteComponent } from '../../commons/tree-autocomplete/tree-autocomplete.component';
import { UtilService } from '../../services/util.service';
import { FraseDia } from '../../models/Util';


@Component({
    selector: 'app-dashboard',
    imports: [
        MatCardModule, RouterLink, MatDividerModule, MatProgressBarModule,
        MatListModule,
        MatBadgeModule,
        MatToolbarModule, MatSlideToggleModule,
        MatButtonModule, MatTooltipModule, MatIconModule,
        AgCharts, AgChartsModule,
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  username: string = ""
  frase: string = ""
  autor: string = ""  

  public chartOptions: AgChartOptions;

  constructor(
    private authService: AuthService,
    private chartsService: ChartsService,
    private utilService: UtilService
  ) {
    inject(AppTitleService).setTitle("Inicio");
    const firstName = this.authService.getTokenData()!.name.split(" ")[0];
    this.username = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    
    this.utilService.getFraseDia().subscribe({
      next: (response) => {
        this.frase = response.phrase;
        this.autor = response.author;
      }
    })  


    this.chartOptions = {}
    this.setDataChart();
    const subscription = interval(500).subscribe({
      next: (value) => {
        if (global.tareas.enElaboracion >= 0){
          this.setDataChart();
          subscription.unsubscribe();
        }
      }
    })
  }

  setDataChart(){
    this.chartOptions = {
      // Data: Data to be displayed in the chart
      data: [
        { bandeja: 'Elaboraci\xF3n', total: global.tareas.enElaboracion||0 },
        { bandeja: 'Recibidos', total: global.tareas.recibido||0 },
        { bandeja: 'Enviados', total: global.tareas.enviado||0 },
        { bandeja: 'Tareas recibidas', total: global.tareas.tareaRecibida||0 },
        { bandeja: 'Tareas enviadas', total: global.tareas.tareaEnviada },
      ],
      // Series: Defines which chart type and data to use
      series: [{ type: 'donut', calloutLabelKey: 'bandeja', angleKey: 'total', innerRadiusRatio: 0.7, calloutLabel: { color: "#8a8a8a" } }]
    };
    this.chartOptions = this.chartsService.initStyleChartOptions(this.chartOptions)
  }
}
